module.exports = __webpack_public_path__ + "assets/img/3023.1850ca87.png";